document.addEventListener('DOMContentLoaded', function() {
  const contactHeading = document.querySelector('#contact-group-wrapper h6');
  const aboutHeading = document.querySelector('#about-group-wrapper h6');
  const socialsHeading = document.querySelector('#socials-group-wrapper h6');
  const serviceHeading = document.querySelector('#service-group-wrapper h6');
  const contactBlock = document.querySelector('#contact-menu');
  const aboutBlock = document.querySelector('#about-menu');
  const socialsBlock = document.querySelector('#socials-menu');
  const servicesBlock = document.querySelector('#service-menu');

  function checkMobile() {
    if (window.innerWidth <= 750) {
      // Mobile: start closed, remove borders
      contactBlock.style.display = 'none';
      aboutBlock.style.display = 'none';
      socialsBlock.style.display = 'none';
      servicesBlock.style.display = 'none';

      contactHeading.classList.remove('is-open');
      aboutHeading.classList.remove('is-open');
      socialsHeading.classList.remove('is-open');
      serviceHeading.classList.remove('is-open');
    } else {
      // Desktop: always open, always bordered
      contactBlock.style.display = 'block';
      aboutBlock.style.display = 'block';
      socialsBlock.style.display = 'block';
      servicesBlock.style.display = 'block';

      contactHeading.classList.add('is-open');
      aboutHeading.classList.add('is-open');
      socialsHeading.classList.add('is-open');
      serviceHeading.classList.add('is-open');
    }
  }

  checkMobile();

  // Toggle handlers (mobile only)
  contactHeading.addEventListener('click', function() {
    if (window.innerWidth > 750) return;
    const isHidden = contactBlock.style.display === 'none' || contactBlock.style.display === '';
    contactBlock.style.display = isHidden ? 'block' : 'none';
    contactHeading.classList.toggle('is-open', isHidden);
  });

  aboutHeading.addEventListener('click', function() {
    if (window.innerWidth > 750) return;
    const isHidden = aboutBlock.style.display === 'none' || aboutBlock.style.display === '';
    aboutBlock.style.display = isHidden ? 'block' : 'none';
    aboutHeading.classList.toggle('is-open', isHidden);
  });

  serviceHeading.addEventListener('click', function() {
    if (window.innerWidth > 750) return;
    const isHidden = servicesBlock.style.display === 'none' || servicesBlock.style.display === '';
    servicesBlock.style.display = isHidden ? 'block' : 'none';
    serviceHeading.classList.toggle('is-open', isHidden);
  });

  socialsHeading.addEventListener('click', function() {
    if (window.innerWidth > 750) return;
    const isHidden = socialsBlock.style.display === 'none' || socialsBlock.style.display === '';
    socialsBlock.style.display = isHidden ? 'block' : 'none';
    socialsHeading.classList.toggle('is-open', isHidden);
  });

  // Optional: if you want this to adapt on resize (desktop <-> mobile)
  window.addEventListener('resize', checkMobile);
});
